import React, { memo } from 'react';
import { GridField } from './gridTypes';

interface GridRowProps {
    row: any;
    rowIndex: number;
    visibleFields: GridField[];
    isSelected: boolean;
    onRowClick: (row: any, e: React.MouseEvent) => void;
    onRowDoubleClick: (row: any) => void;
    onCheckboxChange: (row: any) => void;
    formatCellValue: (value: any, field: GridField, row: any) => React.ReactNode;
    selectionMode: 'none' | 'single' | 'multiple';
}

export const GridRow = memo(({
    row,
    rowIndex,
    visibleFields,
    isSelected,
    onRowClick,
    onRowDoubleClick,
    onCheckboxChange,
    formatCellValue,
    selectionMode
}: GridRowProps) => (
    <tr
        className={`grid-row ${isSelected ? 'grid-row-selected' : ''}`}
        onClick={(e) => onRowClick(row, e)}
        onDoubleClick={() => onRowDoubleClick(row)}
    >
        {selectionMode !== 'none' && (
            <td
                className="grid-td grid-td-checkbox"
                onClick={(e) => {
                    e.stopPropagation();
                    if ((e.target as HTMLElement).tagName !== 'INPUT') {
                        onCheckboxChange(row);
                    }
                }}
            >
                <input
                    type={selectionMode === 'single' ? 'radio' : 'checkbox'}
                    checked={isSelected}
                    onChange={(e) => { e.stopPropagation(); onCheckboxChange(row); }}
                    onClick={(e) => e.stopPropagation()}
                />
            </td>
        )}
        {visibleFields.map((field: GridField) => (
            <td key={field.name} className={`grid-td ${field.cellClass || ''}`}>
                {formatCellValue(row[field.name], field, row)}
            </td>
        ))}
    </tr>
));

GridRow.displayName = 'GridRow';
